import React from 'react';

import Icon from '../Icon/Icon';

const BubblyBlueIcon = (props) => {
    return (
        <Icon width='48' height='48' {...props}>
            <g transform='translate(6 6)' fill='none' fillRule='evenodd'>
                <ellipse stroke='#272A33' strokeWidth='2' cx='13.154' cy='6.48' rx='5.231' ry='5.48' />
                <ellipse stroke='#272A33' strokeWidth='2' cx='27.692' cy='14.4' rx='7.308' ry='7.64' />
                <ellipse stroke='#272A33' strokeWidth='2' cx='10.385' cy='25.2' rx='9.385' ry='9.8' />
                <circle fill='#00D1D2' cx='8.5' cy='30.5' r='1' className='icon-accent-fill' />
                <path
                    d='M10 20c-2.761 0-5 2.453-5 5.478 0 .91.202 1.767.56 2.522'
                    stroke='#00D1D2'
                    strokeWidth='2'
                    strokeLinecap='round'
                    className='icon-accent-stroke'
                />
            </g>
        </Icon>
    );
};

export default BubblyBlueIcon;
